<template>
    <v-app>
        <v-layout row justify-center>
            <v-dialog v-model="loading"  persistent content width="300">
                <v-card
                        color="primary"
                        dark
                >
                    <v-card-text>
                        {{message}}
                        <v-progress-linear
                                indeterminate
                                color="white"
                                class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
        <confirm ref="confirm"></confirm>
        <router-view/>
    </v-app>
</template>

<script>
  import Confirm from '@/components/widgets/dialogs/Confirm'
  export default {
    name: 'App',
    data () {
      return {
        message: 'Loading please wait...'
      }
    },
    computed: {
      user () {
        return this.$store.getters['user/user']
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    components: {
      Confirm
    },
    mounted () {
      if (this.$router.currentRoute.name === 'home') {
        if (this.user !== null) {
          if (this.user.roles.includes('ADMINISTRADOR')) {
            this.$router.push({ name: 'secure.admin' })
          }
          if (this.user.roles.includes('GESTION')) {
            this.$router.push({ name: 'secure.gestion' })
          }
          if (this.user.roles.includes('CLIENTE')) {
            this.$router.push({ name: 'secure.cliente' })
          }
        }
      }
      this.$root.$confirm = this.$refs.confirm.open
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue